<template>
  <div>
    <div>
      <h3 class="title-color">Project Location</h3>
    </div>
    <div class="e-card-separator"></div>
    <div class="main-container">
      <site-info
        @updateSite="updateSite"
        @updateCompanyLegalName="updateCompanyLegalName"
        @updateAddress="updateAddress"
        :company="permit.ePermitSite.siteAddress"
        :site="permit.ePermitSite"
        siteNumberPlaceholder="ASCA Site # (if known): "
        :siteDataSource="sites"
        :sites="sites"
        :siteNumberFields="{ value: 'site_Id' }"
        :municipality="permit.municipality"
      />
      <div class="e-card-separator"></div>

      <div class="sub-container">
        <!-- <select-municipality /> -->
        <div style="display: flex">
          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Lot:"
              v-model="permit.ePermitSite.lot"
              :maxlength="6"
            />
          </div>

          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Block:"
              v-model="permit.ePermitSite.block"
              :maxlength="6"
            />
          </div>

          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Plan:"
              v-model="permit.ePermitSite.plan"
              :maxlength="15"
            />
          </div>
        </div>
        <div style="display: flex">
          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Legal Subdivision:"
              v-model="permit.ePermitSite.atS_LSD"
              :maxlength="2"
            />
          </div>
          <div class="form-row-input">
            <ejs-dropdownlist
              float-label-type="Always"
              placeholder="Quarter:"
              :dataSource="quarters"
              v-model="permit.ePermitSite.atS_QuarterType"
              :maxlength="20"
            />
          </div>
          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Section:"
              v-model="permit.ePermitSite.atS_Section"
              :maxlength="2"
            />
          </div>
        </div>
        <div style="display: flex">
          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Township:"
              v-model="permit.ePermitSite.township"
              :maxlength="3"
            />
          </div>

          <div class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Range:"
              v-model="permit.ePermitSite.range"
              :maxlength="2"
            />
          </div>

          <div class="form-row-input">
            <ejs-dropdownlist
              float-label-type="Always"
              placeholder="Meridian: "
              :dataSource="meridians"
              v-model="permit.ePermitSite.meridian"
              :maxlength="2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="main-container">
      <div class="sub-container">
        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Company Reference ID:"
            v-model="permit.ePermitSite.companyRef"
            :maxlength="50"
          />
        </div>

        <date-info
          ref="estStartDateRef"
          dateType="estStartDate"
          placeHolder="Estimated Commencement Date (MM/DD/YYYY): "
        />

        <date-info
          ref="estEndDateRef"
          dateType="estEndDate"
          placeHolder="Estimated Completion Date (MM/DD/YYYY): "
        />

        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Directions:"
            :multiline="true"
            :rows="3"
            v-model="permit.ePermitSite.directions"
            :maxlength="250"
          />
        </div>

        <div class="form-row-input" ref="descriptionOfWork">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="permit.workDesc"
            :showErrorLabel="showErrorWorkDesc"
            :errorLabelMessage="workDescMessage"
          >
          <ejs-textbox
            float-label-type="Always"
            placeholder="Description of Work: "
            :multiline="true"
            :rows="3"
            v-model="permit.workDesc"
            :maxlength="250"
            cssClass="required"
            @input="
                onInputChange(
                  $event.value,
                  'descriptionOfWork',
                  'showErrorWorkDesc',
                  'workDescMessage'
                )
              "
          />
          </scc-input-validator>
        </div>
      </div>
    </div>

    <div class="main-container">
      <div class="form-row-input">
        <ejs-numerictextbox
          float-label-type="Always"
          placeholder="Value of Installation (Labour and Materials): "
          format="C2"
          :showSpinButton="false"
          v-model="permit.valueOfInstallation"
          :maxlength="250"
        />
      </div>

      <div style="display: flex">
        <div class="form-row-input" style="flex: 1" ref="propertyInsurer">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="permit.propertyInsurer"
            :showErrorLabel="showErrorPropertyInsurer"
            :errorLabelMessage="propertyInsurerMessage"
          >
          <ejs-textbox
            float-label-type="Always"
            placeholder="Commercial Liability/Property Insurer (If Applicable):"
            v-model="permit.propertyInsurer"
            :maxlength="250"
            cssClass="required"
            @input="
                onInputChange(
                  $event.value,
                  'propertyInsurer',
                  'showErrorPropertyInsurer',
                  'propertyInsurerMessage'
                )
              "
          />
          </scc-input-validator>
        </div>
        <div class="form-row-input" style="flex: 1" ref="policyNo">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="permit.policyNo"
            :showErrorLabel="showErrorPolicyNo"
            :errorLabelMessage="policyNoMessage"
          >
          <ejs-textbox
            float-label-type="Always"
            placeholder="Policy # (If Applicable):"
            v-model="permit.policyNo"
            :maxlength="250"
            cssClass="required"
            @input="
                onInputChange(
                  $event.value,
                  'policyNo',
                  'showErrorPolicyNo',
                  'policyNoMessage'
                )
              "
          />
          </scc-input-validator>
        </div>
      </div>

      <div id="work" style="display: flex; gap: 4%" class="form-row-input">
        <ejs-radiobutton
          name="workStatus"
          @change="updateWorkStatus()"
          :checked="permit.ePermitSite.isWorkNotStarted"
          ref="notstarted"
          label="Work has not started"
        />
        <ejs-radiobutton
          name="workStatus"
          @change="updateWorkStatus()"
          :checked="permit.ePermitSite.isWorkInProgress"
          ref="inprogress"
          label="Work is in progress"
        />
        <ejs-radiobutton
          name="workStatus"
          @change="updateWorkStatus()"
          :checked="permit.ePermitSite.isWorkCompleted"
          ref="completed"
          label="Work is complete"
        />
      </div>
    </div>
    <ejs-dialog
      ref="workDialog"
      target="#work"
      header="Work Status"
      :buttons="buttons"
      :content="content"
      width="80%"
      animationSettings="{ effect: 'Zoom' }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import addressInfo from "./common/address-info.vue";
import siteInfo from "./common/site-info.vue";
import DateInfo from "./common/date-info.vue";
import { meridians } from "../../constants";
// import SelectMunicipality from "./common/select-municipality.vue";
import { requiredRule } from "../../../shared/constants";
import sccInputValidator from "../../../components/base/scc-input-validator.vue";

export default {
  components: {
    siteInfo, DateInfo, sccInputValidator,
  },
  name: "ProjectInfo",
  props: {
    sites: Array,
  },
  data() {
    return {
      meridians,
      showErrorWorkDesc: false,
      workDescMessage: null,
      showErrorPropertyInsurer: false,
      propertyInsurerMessage: null,
      showErrorPolicyNo: false,
      policyNoMessage: null,
      requiredRule,
      buttons: [
        {
          click: this.okButtonClick,
          buttonModel: { content: "OK", isPrimary: true },
        },
      ],
      quarters: ['North East', 'North West', 'South East', 'South West'],
      content:
        "<b>Storage tanks regulated under the current edition of the National Fire Code require a permit to be installed, altered or removed as per Alberta Regulation 204/2007 (Permit Regulation). No work shall be started on a storage tank system until a valid permit has been issued by the authority having jurisdiction. Please note that other permits are often required by the local municipality such as but not limited to a development permit and electrical permit.”</b>",
    };
  },
  computed: {
    ...mapGetters({
      permit: "permit",
    }),
  },
  mounted() {
    this.$refs.workDialog.hide();
  },
  methods: {
    onInputChange(val, ref, showError, message) {
      if (val) {
        this[message] = null;
        this[showError] = false;
        // eslint-disable-next-line no-unused-expressions
        this.$refs[ref]?.classList.remove("e-error");
      }
    },
    updateSite(data) {
      if (data) {
        if (data.site_Id) {
          this.permit.ePermitSite.siteId = data.site_Id;
          if (Object.keys(data).length > 1) {
            this.updateSiteInfo(data);
          }
        } else {
          this.updateSiteInfo(data);
        }
      } else {
        // -- cleanup
        this.resetSiteInfo();
      }
    },
    updateAddress(data) {
      const { ePermitSite } = this.permit;
      if (Object.keys(data).length <= 1) return;
      if (data) {
        ePermitSite.siteAddress = {
          address: data.address_Line_1 || '', // address[0] ? address[0].trim() : '',
          cityName: data.siteAddress_City || '', // address[1] ? address[1].trim() : '',
          postalCode: data.siteAddress_PostalZip || '', // address[4] ? address[4].trim() : '',
          provinceName: data.siteAddress_ProvStateType, // ? province.provinceName.trim() : '',
        };
      }
    },
    okButtonClick() {
      this.$refs.workDialog.hide();
    },
    updateWorkStatus() {
      this.permit.ePermitSite.isWorkNotStarted = this.$refs.notstarted.$el.checked;
      this.permit.ePermitSite.isWorkInProgress = this.$refs.inprogress.$el.checked;
      this.permit.ePermitSite.isWorkCompleted = this.$refs.completed.$el.checked;
      if (this.permit.ePermitSite.isWorkInProgress || this.permit.ePermitSite.isWorkCompleted) {
        this.$refs.workDialog.show();
      }
    },
    updateSiteInfo(data) {
      const { ePermitSite } = this.permit;
      if (Object.keys(data).length <= 1) return;

      // const address = data.site_Address.split(',');
      // const province = this.provinces.find((x)
      // => x.provinceCode === data.siteAddress_ProvStateType);
      ePermitSite.siteAddress = {
        address: data.address_Line_1 || '', // address[0] ? address[0].trim() : '',
        cityName: data.siteAddress_City || '', // address[1] ? address[1].trim() : '',
        postalCode: data.siteAddress_PostalZip || '', // address[4] ? address[4].trim() : '',
        provinceName: data.siteAddress_ProvStateType, // ? province.provinceName.trim() : '',
      };

      ePermitSite.lot = data.lot ? data.lot : '';
      ePermitSite.block = data.block ? data.block : '';
      ePermitSite.plan = data.plan ? data.plan : '';
      // ePermitSite.companyRef = data.company_Ref_ID;
      ePermitSite.atS_LSD = data.standard_LSD ? data.standard_LSD : '';
      ePermitSite.atS_Section = data.standard_SEC ? data.standard_SEC : '';
      ePermitSite.township = data.common_TWP ? data.common_TWP : '';
      ePermitSite.range = data.common_REG ? data.common_REG : '';
      ePermitSite.meridian = data.Common_MER ? data.Common_MER : '';
      if (data.site_Name) {
        this.updateCompanyLegalName(data.site_Name);
      }
    },
    resetSiteInfo() {
      const { ePermitSite } = this.permit;
      // const address = data.site_Address.split(',');
      ePermitSite.siteAddress = {
        address: null,
        cityName: null,
        postalCode: null,
        provinceName: null,
      };
      ePermitSite.lot = null;
      ePermitSite.block = null;
      ePermitSite.plan = null;
      ePermitSite.companyRef = null;
      ePermitSite.atS_LSD = null;
      ePermitSite.atS_Section = null;
      ePermitSite.township = null;
      ePermitSite.range = null;
      ePermitSite.meridian = null;
      ePermitSite.siteId = null;
      this.updateCompanyLegalName(null);
    },
    updateCompanyLegalName(val) {
      this.permit.ePermitSite.siteName = val;
    },
  },
};
</script>
